// The calendar draws a log from Zoho's date plus its clock text (start_time/end_time)
// as if that were the browser's own local time (see transformTimelogsToEvents). So
// what a user sees, drags or types IS the clock time to store. Same approach as the
// MW calendar.

// The calendar date of a Date as YYYY-MM-DD, in the browser's own time zone. Never use
// toISOString().split('T')[0] for this: that is the UTC date, so a log starting before
// 02:00 Copenhagen summer time (01:00 in winter) was saved on the previous day.
export const localDateKey = (date) => {
  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// A time as the clock text the user sees, without an offset ("2026-10-13T00:25:00").
// Sending the instant instead made the server read the hour in its own time zone, which
// moves the log for anyone whose browser is not on the server's clock.
export const wallClock = (value) => {
  const d = new Date(value);
  const pad = (n) => String(n).padStart(2, '0');
  return `${localDateKey(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};
